/**
 * Single owner for HTML #initial-loader dismissal.
 * Dispatches once; index.html listens for `blissnet:bootready`.
 */

export function isBootReady(): boolean {
  if (typeof window === 'undefined') return false;
  return !!(window as Window & { __BLISSNET_BOOT_READY__?: boolean }).__BLISSNET_BOOT_READY__;
}

export function signalBootReady(_reason?: string): void {
  if (typeof window === 'undefined') return;
  const w = window as Window & { __BLISSNET_BOOT_READY__?: boolean };
  if (w.__BLISSNET_BOOT_READY__) return;
  w.__BLISSNET_BOOT_READY__ = true;
  window.dispatchEvent(new Event('blissnet:bootready'));
}
